/**
 * 样式计算工具函数
 * 从 MainPage.tsx 提取，用于减少主文件大小
 */

/**
 * 获取时钟位置样式
 * @param type - 'current' (当前时间) 或 'remaining' (剩余时间)
 * @returns CSS 样式对象
 */
export const getClockPositionStyle = (type: 'current' | 'remaining') => {
  const bottomOffset = '45px'; // 往上移动25px，避免挡住YouTube工具栏
  
  if (type === 'current') {
    // 现在时间放在左下角，贴齐左边界保持15px
    return {
      bottom: bottomOffset,
      left: '15px'
    };
  } else {
    // 剩余时间放在右下角，贴齐右边界保持15px
    return {
      bottom: bottomOffset,
      right: '15px'
    };
  }
};

/**
 * 计算最佳缩放比例
 * @param windowWidth - 窗口宽度
 * @param windowHeight - 窗口高度
 * @param isVerticalOrLandscape - 是否为垂直视频或横向模式
 * @returns 最佳缩放比例 (0.5-0.9)
 */
export const calculateOptimalScale = (
  windowWidth: number,
  windowHeight: number,
  isVerticalOrLandscape: boolean
): number => {
  if (!isVerticalOrLandscape) {
    return 1;
  }

  const widthRatio = windowWidth / 800;
  const heightRatio = windowHeight / 600;
  let scale = Math.min(Math.max(Math.min(widthRatio, heightRatio), 0.5), 0.9);
  
  // 手机版额外缩小，确保控制按钮完全可见
  if (windowWidth <= 768) {
    scale = Math.min(scale, 0.65); // 手机版最大缩放65%
  }
  
  return scale;
};

/**
 * 计算最佳控制面板宽度
 * @param windowWidth - 窗口宽度
 * @param isVerticalOrLandscape - 是否为垂直视频或横向模式
 * @returns 控制面板宽度 (200-350px)
 */
export const calculateControlPanelWidth = (
  windowWidth: number,
  isVerticalOrLandscape: boolean
): number => {
  if (!isVerticalOrLandscape) {
    return 350;
  }

  // 计算最佳控制面板宽度（窗口宽度的25%，但不少于200px，不超过300px）
  return Math.max(200, Math.min(windowWidth * 0.25, 300));
};

